import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import SectionLabel from "../site/SectionLabel";

const ease = [0.76, 0, 0.24, 1];
const VIDEO_URL = "/media/ragi-branding.mp4";

export default function BrandVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <section data-testid="home-brand-video" className="relative bg-ink-950 py-24 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="max-w-3xl">
          <SectionLabel number="03">Ragi in Motion</SectionLabel>
          <h2 className="mt-6 font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
            The studio,<br />
            <span className="italic text-gold">in motion.</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease }}
          className="group relative mt-14 overflow-hidden border border-ivory/[0.08] bg-ink-800 shadow-2xl lg:mt-20"
        >
          <video
            ref={videoRef}
            src={VIDEO_URL}
            data-testid="home-brand-video-player"
            className="aspect-video h-full w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink-950/40 via-transparent to-transparent" />
          <button
            type="button"
            onClick={toggleMute}
            aria-label={muted ? "Unmute video" : "Mute video"}
            data-testid="home-brand-video-mute-toggle"
            className="absolute bottom-5 right-5 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-ink-950/60 text-gold backdrop-blur transition-all hover:bg-gold hover:text-ink-950"
          >
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
